import styled from 'styled-components';
import { Text } from 'components/Typography';

const ModalText = styled(Text)`
  color: #2f3036;
`;

export default ModalText;
